import { useLoginMutation, useStaffLogOutMutation, useUserGuestLoginMutation } from "../../features/auth/authApiSlice";
// import { useCreateNewCategoryMutation } from "../../features/category/categoryApiSlice";
import { useCreateNewChapelMutation, useUpdateChapelMutation } from "../../features/chapel/chapelApiSlice";
import { useCreateClientMutation, useDeleteClientMutation, useGenerateNewPINMutation, useUpdateClientInfoMutation, useUpdateClientSpecialPackageMutation } from "../../features/client/clientApiSlice";
import { useAddProductToCartMutation, useCancelledMyOrderMutation, useCheckOutOrderMutation, useRemoveProductCartByIdMutation, useUpdateProductCartMutation, useUpdateQtyProductCartMutation } from "../../features/guest/guestApiSlice";
import { useCreateNewPackageItemsMutation, useCreateNewPackageMutation, useUpdatePackageDetailsMutation, useUpdatePackageItemMutation, useUpdatePackageStatusMutation, useUpdateSpecialPackageDetailsMutation, useUpdateSpecialPackageItemMutation, useUpdateSpecialPackageStatusMutation } from "../../features/package/packageApiSlice";
import { useCreateNewProductMutation, useUpdateProductMutation } from "../../features/product/productApiSlice";
import { useExportBillingReportMutation, useExportSalesExcelMutation } from "../../features/reports/reportsApiSlice";
import { useCreateNewAddonsMutation, useCreateNewCategoryMutation, useCreateNewSizeMutation, useCreateTemperatureMutation, useUpdateAddonsMutation, useUpdateCategoryMutation, useUpdateSizeMutation, useUpdateTemperatureMutation } from "../../features/setup/setupApiSlice";
import { useCreateNewStaffMutation, useUpdateMyAccountInfoMutation, useUpdateStaffMutation } from "../../features/user/usersApiSlice";

export const useMutationData = () => {

    const [updateMyAccountInfo, { isLoading: isLoadingUpdateMyAccount }] = useUpdateMyAccountInfoMutation();
    const [staffLogOut, { isLoading: isLoadingStaffLogOut, isError: isErrorStaffLogOut }] = useStaffLogOutMutation();
    const [createNewStaff, { isLoading: isLoadingCreatingNewStaff }] = useCreateNewStaffMutation();
    const [updateStaff, { isLoading: isLoadingUpdateStaff }] = useUpdateStaffMutation();
    const [newChapel, { isLoading: isLoadingNewChapel, isError: isErrorNewChapel  }] = useCreateNewChapelMutation();
    const [updateChapel, { isLoading: isLoadingUpdateChapel, isError: isErrorUpdateChapel }] = useUpdateChapelMutation();
    const [exportSalesExcel, { isLoading: isLoadingExportSalesExcel }] = useExportSalesExcelMutation();
    const [createNewProduct, { isLoading: isLoadingCreateNewProduct }] = useCreateNewProductMutation();
    const [updateProduct, { isLoading: isLoadingUpdateProduct }] = useUpdateProductMutation();
    const [createPackage, { isLoading: isLoadingCreatePackage, isError: isErrorCreatePackage }] = useCreateNewPackageMutation();
    const [createNewPackageItems, {isLoading: isLoadingCreateNewPackageItems, isError: isErrorCreateNewPackageItems }] = useCreateNewPackageItemsMutation();
    const [updatePackageItems, { isLoading: isLoadingUpdatePackageItems }] = useUpdatePackageItemMutation();
    const [updatePackageDetails, { isLoading: isLoadingUpdatePackageDetails }] = useUpdatePackageDetailsMutation();
    const [updatePackageStatus, { isLoading: isLoadingUpdatePackageStatus }] = useUpdatePackageStatusMutation();
    const [updateSpecialPackageStatus, { isLoading: isLoadingUpdateSpecialPackageStatus }] = useUpdateSpecialPackageStatusMutation();
    const [updateClientInfo, { isLoading: isLoadingUpdateClientInfo }] = useUpdateClientInfoMutation();
    const [loginStaff, { isLoading: isLoadingLoginStaff }] = useLoginMutation()
    const [userGuestLogin, { isLoading: isLoadingUserGuestLogin }] = useUserGuestLoginMutation();
    const [deleteClient, { isLoading: isLoadingDeleteClient }] = useDeleteClientMutation();
    const [generateNewPIN, { isLoading: isLoadingGenerateNewPIN }] = useGenerateNewPINMutation();
    const [createClient, { isLoading: isLoadingCreateClient }] = useCreateClientMutation();
    const [createTemperature, { isLoading: isLoadingCreateTemperature }] = useCreateTemperatureMutation();
    const [updateTemperature, { isLoading: isLoadingUpdateTemperature }] = useUpdateTemperatureMutation();
    const [createAddons, { isLoading: isLoadingCreateAddons }] = useCreateNewAddonsMutation();
    const [updateAddons, { isLoading: isLoadingUpdateAddons }] = useUpdateAddonsMutation();
    const [createCategory, { isLoading: isLoadingCreateCategory }] = useCreateNewCategoryMutation()
    const [updateCategory, { isLoading: isLoadingUpdateCategory }] = useUpdateCategoryMutation() 
    const [createSize, { isLoading: isLoadingCreateSize }] = useCreateNewSizeMutation() 
    const [updateSize, { isLoading: isLoadingUpdateSize }] = useUpdateSizeMutation() 
    const [updateClientSpecialPackage, { isLoading: isLoadingUpdateClientSpecialPackage }] = useUpdateClientSpecialPackageMutation() 

    const [addProductToCart, { isLoading: isLoadingAddProductToCart }] = useAddProductToCartMutation();
    const [updateCartProduct, { isLoading: isLoadingUpdateCartProduct }] = useUpdateProductCartMutation();
    const [cancelledMyOrder, { isLoading: isLoadingCancelledMyOrder }] = useCancelledMyOrderMutation();
    const [removeItemCart, { isLoading: isLoadingRemoveItemCart }] = useRemoveProductCartByIdMutation();
    const [checkOutOrder, { isLoading: isLoadingCheckOutOrder }] = useCheckOutOrderMutation();
    const [updateCartQty, { isLoading: isLoadingUpdateCartQty }] = useUpdateQtyProductCartMutation();

    const [exportBillingReport, { isLoading: isLoadingExportBillingReport }] = useExportBillingReportMutation();
    const [updateSpecialPackageDetails, { isLoading: isLoadingUpdateSpecialPackageDetails }] = useUpdateSpecialPackageDetailsMutation();
    const [updateSpecialPackageItems, { isLoading: isLoadingUpdateSpecialPackageItems }] = useUpdateSpecialPackageItemMutation();

    return {
        updateMyAccountInfo,
        isLoadingUpdateMyAccount,

        staffLogOut,
        isLoadingStaffLogOut,
        isErrorStaffLogOut,

        createNewStaff,
        isLoadingCreatingNewStaff,

        updateStaff,
        isLoadingUpdateStaff,

        newChapel,
        isLoadingNewChapel,
        isErrorNewChapel,

        updateChapel,
        isLoadingUpdateChapel,
        isErrorUpdateChapel,

        createCategory,
        isLoadingCreateCategory,

        updateCategory,
        isLoadingUpdateCategory,

        exportSalesExcel,
        isLoadingExportSalesExcel,

        createNewProduct,
        isLoadingCreateNewProduct,

        updateProduct,
        isLoadingUpdateProduct,

        createPackage,
        isLoadingCreatePackage,
        isErrorCreatePackage,

        createNewPackageItems,
        isLoadingCreateNewPackageItems,
        isErrorCreateNewPackageItems,

        updatePackageItems,
        isLoadingUpdatePackageItems,

        updatePackageDetails,
        isLoadingUpdatePackageDetails,

        updatePackageStatus,
        isLoadingUpdatePackageStatus,

        updateClientInfo,
        isLoadingUpdateClientInfo,

        loginStaff,
        isLoadingLoginStaff,

        userGuestLogin,
        isLoadingUserGuestLogin,

        createClient,
        isLoadingCreateClient,

        deleteClient,
        isLoadingDeleteClient,

        generateNewPIN,
        isLoadingGenerateNewPIN,

        addProductToCart,
        isLoadingAddProductToCart,

        cancelledMyOrder,
        isLoadingCancelledMyOrder,

        removeItemCart,
        isLoadingRemoveItemCart,

        checkOutOrder,
        isLoadingCheckOutOrder,

        updateCartQty,
        isLoadingUpdateCartQty,

        createTemperature,
        isLoadingCreateTemperature,

        updateTemperature,
        isLoadingUpdateTemperature,

        createAddons,
        isLoadingCreateAddons,

        updateAddons,
        isLoadingUpdateAddons,

        createSize,
        isLoadingCreateSize,

        updateSize,
        isLoadingUpdateSize,

        updateClientSpecialPackage,
        isLoadingUpdateClientSpecialPackage,

        exportBillingReport,
        isLoadingExportBillingReport,
        
        updateCartProduct,
        isLoadingUpdateCartProduct,

        updateSpecialPackageStatus,
        isLoadingUpdateSpecialPackageStatus,

        updateSpecialPackageDetails,
        isLoadingUpdateSpecialPackageDetails,

        updateSpecialPackageItems,
        isLoadingUpdateSpecialPackageItems,
    }
}